import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const roreCoefficientsRoutes = [
  {
    path: 'coefficients',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Coefficients')
      },
      permissions: ['READ_RORE_COEFFICIENTS']
    },
    children: [
      {
        path: '',
        name: 'roreCoefficientsList',
        component: wrapLegacyRoute('roreCoefficientsController', 'list')
      },
      {
        path: 'create',
        name: 'roreCoefficientCreate',
        component: wrapLegacyRoute('roreCoefficientsController', 'create')
      },
      {
        path: ':coefficientId(\\d+)',
        name: 'roreCoefficientDetails',
        component: wrapLegacyRoute('roreCoefficientsController', 'details')
      }
    ]
  }
];

export default roreCoefficientsRoutes;
